import { Page } from 'layouts/Page';
import { FC } from 'react';
import { UserChangeHistory } from '../../components/UserManagement/ChangeHistory';

export const UserChangeHistoryPage: FC = () => {
	return (
		<Page title="User Change History – EAS Control Center">
			<UserChangeHistory />
		</Page>
	);
};
